'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './custom-list.routes';
var pluralize = require('pluralize');

export class CustomListComponent {
  constructor(Auth, CustomEntityService, dialogs, $uibModal, $stateParams, SettingsService, $filter, DTOptionsBuilder,
              DTState) {
    'ngInject';
    //this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();
    this.CustomEntityService = CustomEntityService;
    this.isAdmin = Auth.isAdminSync;

    this.dialogs = dialogs;
    this.$uibModal = $uibModal;
    this.$filter = $filter;

    this.type = $stateParams.type;
    this.dehyphendType = this.type.replace(/-/g," ");

    let aggregationColumnsSum = [];

    const REGEX_ALL = /([^\W_]+[^\s-]*) */g;
    const REGEX_FIRST = /([^\W_]+[^\s-]*)/;

    const capitalize = (input, all) => {
      if (!input) return '';
      const regex = (all) ? REGEX_ALL : REGEX_FIRST;
      return input.replace(regex, (txt) =>
        txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
    };

    SettingsService.getByName({name: 'custom-entities'}, settings => {
      this.fields = settings.data.entityList[this.type];
      this.tabs = settings.data.entityListTabs[this.type] ? settings.data.entityListTabs[this.type].tabs : [];
      this.tabsDataAttribute = settings.data.entityListTabs[this.type] ? settings.data.entityListTabs[this.type].data : "";
      this.tabsHiddenAttributes = settings.data.entityListTabs[this.type] ? settings.data.entityListTabs[this.type].hidden : {};

      this.filter = (settings.data.entityListTabs[this.type] && settings.data.entityListTabs[this.type].filter) ? settings.data.entityListTabs[this.type].filter : {};

      this.rowStyle = (settings.data.entityListTabs[this.type] && settings.data.entityListTabs[this.type].rowStyle) ? settings.data.entityListTabs[this.type].rowStyle : {}

      this.CustomEntityService.getByType({type: this.type}, data => {
        this.rawData = data
          .map(entity => {

          let colIndex = -1;
          this.fields.forEach(field => {

            colIndex++;

            if (field.aggregation) {
              switch(field.aggregation) {
                case 'sum':
                default:
                  aggregationColumnsSum.push(colIndex);
              }
            }

            let oData = entity.data[field.data];

            switch (field.type) {
              case 'email':
                entity.data[field.data] = `<a href='mailto:${oData}'>${oData}</a>`;
                break;
              case 'currency':
                entity.data[field.data] = this.$filter('currency')(entity.data[field.data]);
                break;
              case 'date':
                let format = field.format || 'medium';
                entity.data[field.data] = this.$filter('date')(entity.data[field.data], format);
                break;
              case 'reference':

                let oId = entity.data[field.refId];
                if (oId) {  // only replace if there is something to replace
                  switch (field.refType) {
                    case 'community':
                    case 'property':
                    case 'contact':
                    case 'vendor':
                    case 'project':
                      entity.data[field.data] = `<a href='/${field.refType}/${oId}'>${oData}</a>`;
                      break;
                    case 'user':
                      entity.data[field.data] = `<a href='/profile/user/${oId}'>${oData}</a>`;
                      break;
                    case 'entity':
                      entity.data[field.data] = `<a href='/custom/${field.entityType}/${oId}'>${oData}</a>`;
                      break;
                    default:
                      entity.data[field.data] = `<a href='/custom/${field.refType}/${oId}'>${oData}</a>`;
                      break;
                  }
                }

                break;
            }
          });

          return entity;
        });
        this.data = this.rawData;
        this.setFilter('all');
        this.dataInitComplete = true;
      }, err => {
        console.log("Could not retrieve e-forms.")
      })
    });

    this.dtOptions = DTOptionsBuilder
      .newOptions()
      .withOption('dom', 'lBfrtip')
      .withOption('order', [0, 'asc'])
      .withOption('stateSave',true)
      .withOption('stateSaveCallback', DTState.save())
      .withOption('stateLoadCallback', DTState.restore())
      .withOption('lengthMenu', [[10, 25, 50, 100, -1], [10, 25, 50, 100, "All"]])
      .withOption('buttons',[{
        extend: 'excel',
        title: capitalize(this.pluralize(this.dehyphendType), true)
      },{
        extend: 'csv',
        title: capitalize(this.pluralize(this.dehyphendType), true)
      },{
        title: capitalize(this.pluralize(this.dehyphendType), true),
        message: 'As of ' + moment().format("MMMM Do YYYY"),
        extend: 'pdf',
        orientation: 'portrait',
        pageSize: 'LETTER'
      },{
        extend: 'print',
        title: capitalize(this.pluralize(this.dehyphendType), true)
      }])
      .withOption('fnFooterCallback', function ( row, data, start, end, display ) {
        var api = this.api(), data;

        // Remove the formatting to get integer data for summation
        var intVal = function ( i ) {
          return typeof i === 'string' ?
            i.replace(/[\$,]/g, '')*1 :
            typeof i === 'number' ?
              i : 0;
        };

        var roundCorrectly = function(number){ return Math.round(number * 100)/100 };

        aggregationColumnsSum.forEach(colNo => {
          // Total over all pages
          let total = api
            .column( colNo )
            .data()
            .reduce( function (a, b) {
              return intVal(a) + intVal(b);
            }, 0 );

          // Total over this page
          let pageTotal = api
            .column( colNo, { page: 'current'} )
            .data()
            .reduce( function (a, b) {
              return intVal(a) + intVal(b);
            }, 0 );

          // Total over this page
          let visibleTotal = api
            .column( colNo, { search: 'applied'} )
            .data()
            .reduce( function (a, b) {
              return intVal(a) + intVal(b);
            }, 0 );

          // Update footer
          $( api.column( colNo ).footer() ).html(
            '<nobr><span> $'+ $filter('number')(roundCorrectly(visibleTotal), 2) + '</span></nobr>'
          );
        })


      });

  }

  computeRowStyle(entity) {
    let style = {};

    let conditionBuilder = (field, condition, value) => {
      if (!entity.data[field])
        return false;

      let dataValueNumeric = null;
      if (["lt","lte","gt","gte","eq"].includes(condition)) {
        dataValueNumeric = (typeof entity.data[field] == 'string') ? parseFloat(entity.data[field].replace(/,/g,'').replace(/\$/g,'')) : entity.data[field];
      }

      let dataValueDate = null;
      if (condition.startsWith("date:")) {
        dataValueDate = moment(entity.data[field]);

        if (!dataValueDate.isValid())
          return false;
      }

      switch(condition) {
        case 'str:eq':
          return entity.data[field] == value;
        case 'lt':
          return dataValueNumeric < value;
        case 'lte':
          return dataValueNumeric <= value;
        case 'gt':
          return dataValueNumeric > value;
        case 'gte':
          return dataValueNumeric >= value;
        case 'eq':
          return dataValueNumeric == value;
        case 'date:lt':
          switch(value) {
            case 'today':
              return dataValueDate.isBefore(new Date(), 'day');
            default:
              return dataValueDate.isBefore(value, 'day');
          }
        case 'date:lte':
          switch(value) {
            case 'today':
              return dataValueDate.isSameOrBefore(new Date(), 'day');
            default:
              return dataValueDate.isSameOrBefore(value, 'day');
          }
        case 'date:gt':
          switch(value) {
            case 'today':
              return dataValueDate.isAfter(new Date(), 'day');
            default:
              return dataValueDate.isAfter(value, 'day');
          }
        case 'date:gte':
          switch(value) {
            case 'today':
              return dataValueDate.isSameOrAfter(new Date(), 'day');
            default:
              return dataValueDate.isSameOrAfter(value, 'day');
          }
        case 'date:eq':
          switch(value) {
            case 'today':
              return dataValueDate.isSame(new Date(), 'day');
            default:
              return dataValueDate.isSame(value, 'day');
          }
        default:
          return false;
      }
    };

    Object.keys(this.rowStyle).forEach(klass => {
      let multipleConditions = Array.isArray(this.rowStyle[klass][0]);

      style[klass] = multipleConditions
        ? this.rowStyle[klass].every(condition => conditionBuilder(...condition))
        : conditionBuilder(...this.rowStyle[klass]);
    });

    console.log(entity, style);

    return style;
  }

  resetFilter() {
    this.selectedFilter = null;
    this.applyFilter();
  }

  applyFilter() {
    if (this.selectedFilter)
      this.data = this.rawData.filter(row => row.data[this.filter.data] == this.selectedFilter);
    else
      this.data = this.rawData;

    this.setFilter(this.visibleAttribute);
  }

  pluralize(word) {
    return pluralize(word, 2);
  }

  getCount(cat) {
    if (!cat || cat == 'all') {
      return this.data.length;
    } else {
      return this.data.reduce((acc, obj) => {
        return acc + (obj.data[this.tabsDataAttribute] === cat);
      }, 0);
    }
  }

  setFilter(cat) {

    if (!cat || cat == 'all' || !this.tabsDataAttribute) {
      this.filteredData = this.data;
    } else {
      this.filteredData = this.data.filter(entity => entity.data[this.tabsDataAttribute] == cat)
    }

    this.visibleAttribute = cat;
  }

  copyToClipboard(eform) {
    let path = "/e-form/" + eform._id;
    window.prompt("Link to E-Form:", path);
  }

  delete(entity) {
    var that = this;

    var dlg = this.dialogs.confirm("Delete?", "Do you really want to this entity?");
    dlg.result.then(() => {
      // OK delete it
      that.CustomEntityService.delete({id: entity._id},
        () => {
          that.data = that.data.filter(function( obj ) {
            return obj._id !== entity._id;
          });
        },
        err => {
          alert("Could not delete custom entity");
        });
    }, () => {
      // Cancel
    });
  }

}

export default angular.module('conduu.customList', [uiRouter])
  .config(routes)
  .component('customList', {
    template: require('./custom-list.html'),
    controller: CustomListComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/custom/list/custom-list.component.js